// Autocomplétion d'adresses françaises via la Géoplateforme (IGN) : service public,
// gratuit, sans clé, CORS ouvert. On utilise fetch (et non authAxios) pour ne jamais
// envoyer le token de l'utilisateur à un service tiers.
const GEOCODING_URL = 'https://data.geopf.fr/geocodage/search';
const MIN_QUERY_LENGTH = 3;
const MAX_SUGGESTIONS = 6;

export interface AddressSuggestion {
    id: string;
    label: string;
    street: string;
    zipCode: string;
    city: string;
    latitude: number;
    longitude: number;
    // 'housenumber' = position du numéro, 'street' = point sur la rue (approximatif)
    precision: 'housenumber' | 'street';
}

interface GeocodingFeature {
    geometry: { coordinates: [number, number] };
    properties: {
        id: string;
        label: string;
        name: string;
        postcode?: string;
        city?: string;
        type: string;
    };
}

export const addressService = {
    minQueryLength: MIN_QUERY_LENGTH,

    async search(query: string, signal?: AbortSignal): Promise<AddressSuggestion[]> {
        const params = new URLSearchParams({
            q: query.trim(),
            limit: '10',
            autocomplete: '1',
        });

        const response = await fetch(`${GEOCODING_URL}?${params.toString()}`, { signal });
        if (!response.ok) {
            throw new Error(`Address search failed (${response.status})`);
        }

        const data: { features?: GeocodingFeature[] } = await response.json();

        // On ne garde que les adresses (pas les communes ni les lieux-dits)
        return (data.features || [])
            .filter(f => f.properties.type === 'housenumber' || f.properties.type === 'street')
            .slice(0, MAX_SUGGESTIONS)
            .map(f => ({
                id: f.properties.id,
                label: f.properties.label,
                street: f.properties.name,
                zipCode: f.properties.postcode || '',
                city: f.properties.city || '',
                longitude: f.geometry.coordinates[0],
                latitude: f.geometry.coordinates[1],
                precision: f.properties.type as 'housenumber' | 'street',
            }));
    },
};
